import React from 'react';

const AboutSection = () => {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-deep-blue font-montserrat">ABOUT PROTEC</h2>
        </div>
        
        <div className="flex flex-col md:flex-row items-center">
          <div className="md:w-1/2 mb-8 md:mb-0 md:pr-8">
            <p className="text-lg text-charcoal mb-4">
              Protec Services and Distribution specializes in the assembly of automotive monitors and interior electronics parts, delivering precision and quality for the automotive industry.
            </p>
            <p className="text-lg text-charcoal mb-4">
              With our expertise in electronics assembly and global distribution network, we ensure that our clients receive top-quality components that meet the highest industry standards.
            </p>
            <a
              href="/about"
              className="inline-block bg-deep-blue hover:bg-blue-800 text-white font-montserrat font-semibold uppercase tracking-wider py-2 px-6 border border-transparent rounded-md shadow-md transition duration-300"
            >
              LEARN MORE
            </a>
          </div>
          <div className="md:w-1/2">
            {/* This would be replaced with an actual image in production */}
            <div className="bg-light-gray h-64 rounded-lg shadow-md bg-[url('https://images.unsplash.com/photo-1581092160607-ee22731c9c8c?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80')] bg-cover bg-center"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
